import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ApiDonationEnvelope,
  ApiDonationResponse,
} from '../api-model/donation-upload';

/**
 * Service that handles donation data
 */
@Injectable({
  providedIn: 'root',
})
export class DonationNextApi {
  private readonly http = inject(HttpClient);

  /**
   * Persists a new donation from the given `data`.
   *
   * @param data Donation data
   *
   * @returns
   * An `Observable` of the response
   */
  create(data: unknown): Observable<ApiDonationResponse> {
    const url = '/api/next/donations/';

    // Create donation on server
    return this.http.post<ApiDonationResponse>(url, data);
  }

  /**
   * Patches an existing Unfinished Donation
   *
   * @param id The `id` of the Unfinished Donation to patch
   * @param data Updated Donation data
   *
   * @returns
   * An `Observable` of the response
   */
  patch(
    data: ApiDonationEnvelope,
    id: string,
  ): Observable<ApiDonationResponse> {
    const url = `/api/next/unfinished_donations/${id}/`;

    // Update Unfinished Donation on server
    return this.http.put<ApiDonationResponse>(url, data);
  }
}
